import { render, staticRenderFns } from "./ScreeningHouseholdSummaryIncome.vue?vue&type=template&id=0ce525c0&scoped=true&"
import script from "./ScreeningHouseholdSummaryIncome.vue?vue&type=script&lang=js&"
export * from "./ScreeningHouseholdSummaryIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce525c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
